import type {
    NextStepsFragment_slackMessage,
    NextStepsFragment_nutshellNotification,
} from 'nutshell-graphql-types';

import FORM_FRAGMENT from '../../graphql/fragments/form-fragment.graphql';

export function nextStepsCacheUpdate({
    client,
    formId,
    nextStepsKey,
    nextStep,
}: {
    client: any;
    formId: string;
    nextStepsKey: 'slackMessage' | 'nutshellNotification';
    nextStep:
        | NextStepsFragment_slackMessage
        | NextStepsFragment_nutshellNotification
        | null
        | undefined;
}) {
    const formFragment = client.readFragment({
        id: formId,
        fragmentName: 'FormFragment',
        fragment: FORM_FRAGMENT,
    });

    if (formFragment) {
        client.writeFragment({
            id: formId,
            fragment: FORM_FRAGMENT,
            fragmentName: 'FormFragment',
            data: {
                ...formFragment,
                nextSteps: {
                    ...formFragment.nextSteps,
                    [nextStepsKey]: nextStep,
                },
            },
        });
    }
}
